import { formatDateUtil } from "@utils/date.util";
import { PRIMARY_KEY } from "@constants/app.constants";

const tableTitle = "Pages List";
const keyColumn = PRIMARY_KEY;
const menuUrl = "pages";
const tableColumn = [
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
  },
  {
    id: "meta_data",
    numeric: false,
    disablePadding: false,
    label: "Meta Data",
  },
  {
    id: "slug",
    numeric: false,
    disablePadding: false,
    label: "Slug",
  },

  {
    id: "created_at",
    numeric: false,
    disablePadding: false,
    label: "Created At",
    formatData: formatDateUtil,
  },
];
const breadCrumbs = [{ name: "Pages", menu_url: "/pages" }];

const filters = [
  {
    name: "title",
    id: "title",
    label: "Title",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
  {
    name: "slug",
    id: "slug",
    label: "Slug",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];

export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
};
